import { apiFetch } from "#lib/api";

interface IResult {
  id: string;
  service: string;
  name: string;
  indexed: string;
  updated: string;
  public_id: string | null;
  relation_id: number | null;
}

export async function fetchRecommendedCreators(service: string, creatorId: string) {
  const path = `/${service}/user/${creatorId}/recommended`;
  return await apiFetch<IResult[]>(path);
}
